// Text constants for the application
export const APP_STRINGS = {
  // App/Header related
  APP_NAME: 'TravReferral',
  PRODUCT_NAME: 'Travreferal',
  SEARCH_PROVIDERS: 'Search Providers',


  // Navigation
  SELECT_DIFFERENT_BUSINESS: 'Select Different Line of Business',

  // Landing Page
  PAGE_HEADER: 'TravReferral Unit Selection',
  DESCRIPTION_TEXT: 'Please select your unit before proceeding.',
  EXTERNAL_TRAVELERS_HEADER: 'External-Travelers',

  // Units/Business Lines

  AUTO: 'Auto',
  AUTO_MEDICAL: 'Auto Medical',
  PROPERTY: 'Property',


  // Form related
  SEARCH: 'Search',
  RESET: 'Reset',
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
  EXPORT: 'EXPORT',
  LOADING: 'Loading...',
  SEARCHING: 'Searching...',
  NETWORK_SELECTION: 'All Auto Repair Shops',


  // Messages
  NO_RESULTS_FOUND: 'No results found',
  ERROR_MESSAGE: 'An error occurred. Please try again.',
  SUCCESS_MESSAGE: 'Operation completed successfully',

  // Accessibility
  MAIN_NAVIGATION: 'Main navigation',
  SEARCH_FORM: 'Search form',
  RESULTS_TABLE: 'Search results table',

  // Common
  HOME: 'Home',
  BACK: 'Back',
  NEXT: 'Next',
  PREVIOUS: 'Previous',
  CLOSE: 'Close',
} as const;

// Export individual categories for easier imports
export const NAVIGATION_TEXT = {
  SELECT_DIFFERENT_BUSINESS: APP_STRINGS.SELECT_DIFFERENT_BUSINESS,
  HOME: APP_STRINGS.HOME,
  BACK: APP_STRINGS.BACK,
  SEARCH_PROVIDERS: APP_STRINGS.SEARCH_PROVIDERS,
} as const;

export const FORM_TEXT = {
  SEARCH: APP_STRINGS.SEARCH,
  RESET: APP_STRINGS.RESET,
  CANCEL: APP_STRINGS.CANCEL,
  SUBMIT: APP_STRINGS.SUBMIT,
  EXPORT: APP_STRINGS.EXPORT,
  EMAIL_SELECTED: 'EMAIL SELECTED',
  LOADING: APP_STRINGS.LOADING,
  SEARCHING: APP_STRINGS.SEARCHING,
  NETWORK_SELECTION: APP_STRINGS.NETWORK_SELECTION,
} as const;

export const PROPERTY_OWNER_DETAILS = {
  FIRST_NAME: 'Dan',
  LAST_NAME: 'Mullaney',
  EMAIL: 'DMULLANE@travelers.com',
}


export const COMMON_TEXT = {
  LOADING: APP_STRINGS.LOADING,
  SEARCHING: APP_STRINGS.SEARCHING,
  NO_RESULTS_FOUND: APP_STRINGS.NO_RESULTS_FOUND,
  ERROR_MESSAGE: APP_STRINGS.ERROR_MESSAGE,
  SUCCESS_MESSAGE: APP_STRINGS.SUCCESS_MESSAGE,
} as const;

// Auto Search specific constants
export const AUTO_SEARCH_TEXT = {
  // Page content
  PAGE_TITLE: 'Auto Search',
  PAGE_DESCRIPTION: 'Search for auto repair providers in your network.',
  SEARCH_FORM_TITLE: 'Search Providers',

  // Search form
  SEARCH_TYPE_LABEL: 'Search Type',
  LOCAL_SEARCH: 'Local Search',
  NAME_SEARCH: 'Name Search',
  SEARCH_BUTTON: 'SEARCH',
  CLEAR_SEARCH: 'RESET',

  // Form fields
  DISTANCE_HELP: 'Enter distance in miles (optional)',

  // Validation messages
  VALIDATION: {
    STATE_REQUIRED: 'State is required',
    DISTANCE_INVALID: 'Distance must be a positive number',
    SERVICE_NAME_REQUIRED: 'Service name is required',
  },

  // Search results
  SEARCH_RESULTS_PREFIX: 'Search Results: ',
  SEARCH_RESULTS_EMPTY: 'Search Results: ""',
  SEARCH_RESULTS_NO_MATCHES: 'Search Results: No matches found',
  NO_RESULTS_FOUND: 'No Results Found',
  SEARCH_RESULTS: 'Search Results',
  VIEW_DETAILS: 'View Details',

  // Table headers
  TABLE_HEADERS: {
    NAME: 'Name',
    ADDRESS: 'Address',
    PHONE: 'Phone',
    SERVICES: 'Services',
    ACTIONS: 'Actions',
  },



  // Help text
  ADMIN_HELP_TEXT: 'To edit multiple fields for a provider, use the Edit button. For bulk edits, select providers and click Export.',
  EXTERNAL_DISCLAIMER: '*Travelers policyholders are under no obligation to use any particular repair vendor. Any use of a vendor is strictly voluntary.*',
  PROPERTY_DISCLAIMER: `Independent contractors on this list are not employees or affiliates of Travelers. Travelers does not perform repairs, retain contractors for customers or guarantee the quality of repair work. Travelers customers are under no obligation to use any particular contractor and the use of a particular contractor is strictly voluntary. Travelers customers are responsible for the selection of the contractor and payments to the contractor for the work performed. The cost of the repair or mitigation services can be submitted to Travelers for consideration and reimbursement but is subject to a review of the coverage afforded by the customer's policy.`,
  // Table columns
  VENDOR_NAME: 'Vendor Name',
  VENDOR_ID: 'Vendor ID',
  ADDRESS: 'Address',
  PHONE: 'Phone',
  STATUS: 'Status',
  ACTIONS: 'Actions',
  APPROXIMATE_MILES: 'Approximate Miles',

  // Sorting
  SORT_A_TO_Z: 'A to Z',
  SORT_Z_TO_A: 'Z to A',


  // Table settings
  SORT_MODE_SIMPLE: 'simple',
  EDIT_MODE_ROW: 'row',
  SORT_ORDER_ASCENDING: 'ascending',
  SELECTED_PATH: 'isSelected',
} as const;

export const UNIT_LABELS = {
  AUTO: APP_STRINGS.AUTO,
  AUTO_MEDICAL: APP_STRINGS.AUTO_MEDICAL,
  PROPERTY: APP_STRINGS.PROPERTY,
} as const;


// Add vendorType constant for use in forms and field names
export const FIELDNAME = {
  VENDOR_TYPE: 'vendorType',
  VENDOR_SPECIALITY: 'vendorSpecialty',
  APPROVAL_STATUS: 'approvalStatus',
  STATE: 'state',
  NETWORK_SELECTION: 'networkSelection',
} as const;

export const PAGE_NOT_FOUND = {
  TITLE: 'Page Not Found',
  MESSAGE: 'The page you are looking for does not exist.',
} as const;

//export const AUTO_DISCLAIMER = "You are under no obligation to use any particular repair facility. \nYou have the right to have your vehicle repaired at the shop of your choice. \nUse of a participating repair facility is strictly voluntary."
//export const PROPERTY_DISCLAIMER = "You are under no obligation to use any particular repair facility. \nYou have the right to have your vehicle repaired at the shop of your choice. \nUse of a participating repair facility is strictly voluntary."

// Disclaimers for different business lines
export const DISCLAIMER = {
  AUTO: "You are under no obligation to use any particular repair facility. \nYou have the right to have your vehicle repaired at the shop of your choice. \nUse of a participating repair facility is strictly voluntary.",
  PROPERTY: "Travelers policyholders are under no obligation to use any particular repair facility. \nI understand that the use of a participating repair facility is strictly voluntary."
} as const;

// Error messages for API and user interactions
export const ERROR_MESSAGES = {
  // Network and connection errors
  NETWORK_ERROR: 'Unable to connect to the server. Please check your internet connection. (Network Error)',
  OFFLINE_ERROR: 'You appear to be offline. Please check your internet connection.',

  // Authentication errors
  SESSION_EXPIRED: 'Your session has expired. Please log in again. (Error 401)',
  SESSION_EXPIRED_EXPORT: 'Your session has expired. Please log in again and retry the export. (Error 401)',
  PERMISSION_DENIED: 'You do not have permission to view this data. (Error 403)',
  PERMISSION_DENIED_EXPORT: 'You do not have permission to export this data. (Error 403)',
  PERMISSION_DENIED_SEARCH: 'You do not have permission to search vendors. (Error 403)',

  // Server errors
  BAD_REQUEST: 'Invalid search criteria. Please check your inputs and try again. (Error 400)',
  NOT_FOUND: 'No vendors found matching your search criteria. (Error 404)',
  SERVER_ERROR: 'Server error occurred. Please try again later. (Error 500)',
  SERVER_ERROR_EXPORT: 'Server error occurred during export. Please try again later. (Error 500)',
  SERVICE_UNAVAILABLE: 'Service temporarily unavailable. Please try again later. (Error 503)',
  SERVICE_UNAVAILABLE_DETAIL: 'Service temporarily unavailable. The server is currently unable to handle the request. (Error 503)',

  // Timeout errors
  TIMEOUT_ERROR: 'Search is taking longer than expected. Please try with fewer filters. (Timeout Error)',
  TIMEOUT_ERROR_EXPORT: 'Export is taking longer than expected. Please try with fewer vendors. (Timeout Error)',
  TIMEOUT_ERROR_EXPORT_ALL: 'Export is taking longer than expected. Please try with fewer vendors or a smaller date range. (Timeout Error)',

  // Generic errors
  GENERIC_LOAD_ERROR: 'Unable to load vendors. Please try again later.',
  GENERIC_SEARCH_ERROR: 'Unable to search vendors. Please try again later.',
  GENERIC_EXPORT_ERROR: 'Unable to export vendors. Please try again later.',
  GENERIC_EXPORT_ALL_ERROR: 'Unable to export all vendors. Please try again or contact support if the problem persists.',
  GENERIC_EXPORT_SUPPORT: 'Unable to export vendors. Please try again or contact support if the problem persists.',
  UNEXPECTED_ERROR: 'An unexpected error occurred. Please try again later.',

  // Processing errors
  EXPORT_PARSE_ERROR: 'Unable to process export data. Please try again.',
  NETWORK_ERROR_EXPORT: 'Unable to export vendors. Please check your connection and try again. (Network Error)',
  NETWORK_ERROR_EXPORT_DETAIL: 'Unable to export vendors due to network issues. Please check your connection and try again. (Network Error)',

  // Reference code errors
  REFERENCE_CODE_ERROR: 'Error occurred in the system. Try again later or contact FOSS.',
} as const;
